import "./index.css";

const TermsPage = () => {
  return (
    <div className="termsContainer">
      <header>
        <h1 style={{ textAlign: "left" }}>Terms and Conditions</h1>
        <i>Last updated: 2026-01-10</i>
      </header>

      <section>
        <h2 style={{ marginTop: "30px" }}>1. Introduction</h2>
        <div className="pDiv">
          <p>
            Welcome to Bonfiire! These Terms and Conditions ("Terms") govern
            your access to and use of Bonfiire's app, website, and services
            (collectively referred to as "Services"). By accessing or using our
            Services, you agree to comply with these Terms. We encourage you to
            read them carefully before using our Services.
          </p>
        </div>
      </section>

      <section>
        <h2 style={{ textAlign: "left", marginTop: "30px" }}>
          2. Acceptance of Terms
        </h2>
        <div className="pDiv">
          <p>
            By creating an account or using our Services, you acknowledge that
            you have read, understood, and agree to be bound by these Terms. If
            you do not agree, you must cease using our Services immediately.
          </p>
        </div>
      </section>

      <section style={{ textAlign: "left", marginTop: "30px" }}>
        <h2>3. We as a platform</h2>
        <article className="pDiv">
          <p>
            Bonfiire acts as a platform that enables individual users to
            organize and manage their events/hangouts, and create social
            connections. Bonfiire is not an event organizer or host. As such, we
            do not take responsibility for any issues, disputes, or liabilities
            arising from events/hangouts organized by users on our platform.
            This includes, but is not limited to:
          </p>
        </article>

        <section>
          <ul style={{ paddingLeft: "40px", marginTop: "10px" }}>
            <li>
              <div className="pDiv">
                <p>
                  We are not directly involved in the planning, execution, or
                  safety of any events/hangouts.
                </p>
              </div>
            </li>
            <li>
              <div className="pDiv">
                <p>
                  You acknowledge that Bonfiire does not vet users or event
                  locations. You attend any event or hangout found via the
                  platform entirely at your own risk.
                </p>
              </div>
            </li>
            <li>
              <div className="pDiv">
                <p>
                  Event hosts are solely responsible for the accuracy of event
                  details and for ensuring their events comply with local laws
                  and safety regulations.
                </p>
              </div>
            </li>
            <li>
              <div className="pDiv">
                <p>
                  If you have any questions or issues with an event/hangout,
                  please reach out to the event host directly. Hosts are in
                  charge of their events/hangouts and are responsible for
                  sharing any specific terms or policies that might apply to
                  you.
                </p>
              </div>
            </li>
          </ul>
        </section>
      </section>

      <section>
        <h2 style={{ textAlign: "left", marginTop: "30px" }}>
          4. User Registration
        </h2>
        <div className="pDiv">
          <p>
            To access certain features of our Services, you may need to create
            an account. By registering, you agree to:
          </p>
        </div>
        <section>
          <ul style={{ paddingLeft: "40px", marginTop: "10px" }}>
            <li>
              <div className="pDiv">
                <p>
                  Provide accurate, up-to-date, and complete information about
                  yourself during registration.
                </p>
              </div>
            </li>
            <li>
              <div className="pDiv">
                <p>
                  Update your information as necessary to ensure its accuracy.
                </p>
              </div>
            </li>
            <li>
              <div className="pDiv">
                <p>
                  Maintain the confidentiality of your account credentials and
                  secure access to your account.
                </p>
              </div>
            </li>
            <li>
              <div className="pDiv">
                <p>
                  You are solely responsible for all activities that occur under
                  your account. If you suspect unauthorized access or a security
                  breach, you agree to notify us immediately.
                </p>
              </div>
            </li>
          </ul>
        </section>
      </section>

      <section>
        <h2 style={{ textAlign: "left", marginTop: "30px" }}>
          5. Use of Services
        </h2>
        <article className="pDiv">
          <p>
            By using our Services, you agree to comply fully with all applicable
            laws, regulations, and these Terms. You may not use our Services for
            any unlawful, harmful, or malicious purposes. Additionally, you
            agree not to engage in any activity that could damage, disable,
            overburden, or otherwise interfere with the proper functioning,
            security, or integrity of our Services, including, but not limited
            to, attempts to hack, exploit vulnerabilities, or disrupt access for
            other users.
          </p>
        </article>
      </section>

      <section style={{ textAlign: "left", marginTop: "30px" }}>
        <h2>6. User Conduct and Responsibilities</h2>
        <article className="pDiv">
          <p>You agree to the following user responsibilities:</p>
        </article>

        <section>
          <h3 style={{ textAlign: "left" }}>6.1 Respect Other Users</h3>
          <ul style={{ paddingLeft: "40px", marginTop: "10px" }}>
            <li>
              <div className="pDiv">
                <p>
                  Avoid any behavior or content that could harm, harass, bully,
                  or discriminate against other users.
                </p>
              </div>
            </li>
            <li>
              <div className="pDiv">
                <p>
                  Treat all users with courtesy and dignity, irrespective of
                  their background, beliefs, or opinions.
                </p>
              </div>
            </li>
          </ul>
        </section>

        <section>
          <h3 style={{ textAlign: "left", marginTop: "30px" }}>
            6.2 No Harmful or Violent Content
          </h3>
          <ul style={{ paddingLeft: "40px", marginTop: "10px" }}>
            <li>
              <div className="pDiv">
                <p>
                  Refrain from sharing content that promotes violence, hate
                  speech, or any form of abuse.
                </p>
              </div>
            </li>
            <li>
              <div className="pDiv">
                <p>
                  Do not threaten or intimidate other users through messages, or
                  any interaction on the platform.
                </p>
              </div>
            </li>
          </ul>
        </section>

        <section>
          <h3 style={{ textAlign: "left", marginTop: "30px" }}>
            6.3 Protect User Privacy
          </h3>
          <ul style={{ paddingLeft: "40px", marginTop: "10px" }}>
            <li>
              <div className="pDiv">
                <p>
                  Respect the privacy of others by not sharing their personal
                  information without consent.
                </p>
              </div>
            </li>
            <li>
              <div className="pDiv">
                <p>
                  Do not engage in doxxing or any activity that compromises the
                  safety of other users.
                </p>
              </div>
            </li>
          </ul>
        </section>

        <section>
          <h3 style={{ textAlign: "left", marginTop: "30px" }}>
            6.4 Foster a Safe Environment
          </h3>
          <ul style={{ paddingLeft: "40px", marginTop: "10px" }}>
            <li>
              <div className="pDiv">
                <p>
                  Avoid posting or transmitting content that incites conflict,
                  spreads misinformation, or creates a hostile atmosphere.
                </p>
              </div>
            </li>
            <li>
              <div className="pDiv">
                <p>
                  Report any inappropriate or harmful behavior to the platform
                  administrators immediately.
                </p>
              </div>
            </li>
          </ul>
        </section>

        <section>
          <h3 style={{ textAlign: "left", marginTop: "30px" }}>
            6.5 Follow Anti-Bullying Guidelines
          </h3>
          <ul style={{ paddingLeft: "40px", marginTop: "10px" }}>
            <li>
              <div className="pDiv">
                <p>
                  Do not engage in cyberbullying, such as sending malicious
                  messages, or targeting individuals repeatedly.
                </p>
              </div>
            </li>
            <li>
              <div className="pDiv">
                <p>
                  Help maintain a supportive and positive community by
                  addressing issues constructively and respectfully.
                </p>
              </div>
            </li>
          </ul>
        </section>

        <section>
          <h3 style={{ textAlign: "left", marginTop: "30px" }}>
            6.6 Use Bonfiire Services Responsibly
          </h3>
          <ul style={{ paddingLeft: "40px", marginTop: "10px" }}>
            <li>
              <div className="pDiv">
                <p>
                  Do not misuse the platform or its features to harm, disrupt,
                  or exploit Bonfiire’s services or other users.
                </p>
              </div>
            </li>
            <li>
              <div className="pDiv">
                <p>
                  Avoid any attempts to hack, interfere with, or undermine the
                  proper functioning of Bonfiire’s infrastructure.
                </p>
              </div>
            </li>
            <li>
              <div className="pDiv">
                <p>
                  Use the platform for its intended purposes and refrain from
                  actions that violate its terms of service.
                </p>
              </div>
            </li>
          </ul>
        </section>
        <article className="pDiv">
          <p>
            By adhering to these rules, you help maintain Bonfiire as a safe,
            welcoming, and positive space for all users.
          </p>
        </article>
      </section>

      <section>
        <h2 style={{ textAlign: "left", marginTop: "30px" }}>
          7. Privacy and Data Collection
        </h2>
        <div className="pDiv">
          <p>
            Your use of our Services is governed by our Privacy Policy, which
            outlines how we collect, use, and safeguard your personal
            information. By using the Services, you consent to the practices
            described in our Privacy Policy.
          </p>
        </div>
      </section>

      <section>
        <h2 style={{ textAlign: "left", marginTop: "30px" }}>
          8. Payment and Fees
        </h2>
        <div className="pDiv">
          <p>
            Currently, our platform does not process any financial transactions.
            However, in the future, we may offer paid services, in-app
            purchases, or other monetized features. All such transactions will
            be handled by third-party payment processors, and we will update our
            Terms and Conditions to reflect any changes.
          </p>
        </div>
      </section>

      <section>
        <h2 style={{ textAlign: "left", marginTop: "30px" }}>
          9. Third-Party Links and Services
        </h2>
        <div className="pDiv">
          <p>
            Our Services may contain links to third-party websites or services
            that are not owned or controlled by Bonfiire. We do not endorse or
            take responsibility for the content or practices of these
            third-party sites. You access them at your own risk.
          </p>
        </div>
      </section>

      <section>
        <h2 style={{ textAlign: "left", marginTop: "30px" }}>
          10. Termination of Account
        </h2>
        <div className="pDiv">
          <p>
            We reserve the right to suspend or terminate your account and access
            to our Services at our discretion, without notice, if you violate
            these Terms or engage in any behavior that harms the platform, other
            users, or disrupts the functioning of the Services.
          </p>
        </div>
      </section>

      <section>
        <h2 style={{ textAlign: "left", marginTop: "30px" }}>
          11. Intellectual Property
        </h2>
        <div className="pDiv">
          <p>
            The content, features, and functionality of the Bonfiire platform
            are owned by us and protected by intellectual property laws. You may
            not copy, modify, distribute, or create derivative works based on
            our content without prior written consent.
          </p>
        </div>
      </section>

      <section style={{ textAlign: "left", marginTop: "30px" }}>
        <h2>12. Disclaimers and Limitations of Liability</h2>
        <ul style={{ paddingLeft: "40px", marginTop: "10px" }}>
          <li>
            <div className="pDiv">
              <p>
                No Warranty: Our Services are provided "as is," without any
                warranty or representation of any kind, express or implied. We
                do not guarantee the accuracy, reliability, or availability of
                the Services, and users use the Services at their own risk.
              </p>
            </div>
          </li>
          <li>
            <div className="pDiv">
              <p>
                Limitation of Liability: Bonfiire will not be liable for any
                indirect, incidental, special, or consequential damages arising
                from your use or inability to use the Services.
              </p>
            </div>
          </li>
        </ul>
      </section>

      <section>
        <h2 style={{ textAlign: "left", marginTop: "30px" }}>
          13. Indemnification
        </h2>
        <div className="pDiv">
          <p>
            You agree to indemnify and hold harmless Bonfiire, its officers,
            employees, agents, and affiliates from any claims, damages,
            liabilities, costs, or expenses arising from your use of the
            Services, your violation of these Terms, or your infringement of any
            intellectual property or other rights of third parties.
          </p>
        </div>
      </section>

      <section>
        <h2 style={{ textAlign: "left", marginTop: "30px" }}>
          14. Governing Law
        </h2>
        <div className="pDiv">
          <p>
            These Terms will be governed by and construed in accordance with the
            laws of the jurisdiction in which Bonfiire operates. Any disputes
            arising from these Terms will be resolved in the appropriate courts
            of that jurisdiction.
          </p>
        </div>
      </section>

      <section>
        <h2 style={{ textAlign: "left", marginTop: "30px" }}>
          15. Modifications
        </h2>
        <div className="pDiv">
          <p>
            Bonfiire reserves the right to modify, suspend, or terminate any
            part of the Services at any time, for any reason, without notice. We
            may also update or amend these Terms from time to time. Any changes
            will take effect immediately upon posting on this page. It is your
            responsibility to review these Terms periodically for any updates.
          </p>
        </div>
      </section>

      <section>
        <h2 style={{ textAlign: "left", marginTop: "30px" }}>
          16. Platform Accessibility & Availability
        </h2>
        <div className="pDiv">
          <p>
            Bonfiire strives to maintain uninterrupted access to our Services,
            but we do not guarantee that the platform will be available at all
            times. We are not responsible for any downtime, service
            interruptions, or technical issues that may prevent you from
            accessing the platform. You acknowledge that access to Bonfiire may
            occasionally be limited or disrupted due to maintenance, upgrades,
            or unforeseen technical issues.
          </p>
        </div>
      </section>

      <section>
        <h2 style={{ textAlign: "left", marginTop: "30px" }}>
          17. User-Generated Content
        </h2>
        <div className="pDiv">
          <p>
            By using Bonfiire, you retain ownership of the content you create
            and upload to the platform. However, by submitting or posting
            content on Bonfiire, you grant us a worldwide, non-exclusive,
            royalty-free, and sublicensable license to use, display, and
            distribute your content within the platform and for promotional
            purposes related to the Services.
          </p>
        </div>
      </section>

      <section>
        <h2 style={{ textAlign: "left", marginTop: "30px" }}>
          18. Content Moderation and Reporting
        </h2>
        <div className="pDiv">
          <p>
            Bonfiire reserves the right to monitor, remove, or restrict access
            to any content that violates these Terms or is deemed harmful,
            offensive, or illegal. We encourage users to report any
            inappropriate or harmful content by using the in-app reporting tools
            or contacting us directly. We will investigate and take appropriate
            actions as needed, in accordance with our policies and applicable
            laws.
          </p>
        </div>
      </section>

      <section>
        <h2 style={{ textAlign: "left", marginTop: "30px" }}>
          19. Dispute Resolution
        </h2>
        <div className="pDiv">
          <p>
            In the event of any disputes or issues arising out of your use of
            Bonfiire’s Services, we encourage you to reach out to us directly to
            seek a resolution. If the issue cannot be resolved informally, we
            may seek resolution under Finnish law.
          </p>
        </div>
      </section>

      <section>
        <h2 style={{ textAlign: "left", marginTop: "30px" }}>
          20. International Users
        </h2>
        <div className="pDiv">
          <p>
            Bonfiire is intended for users globally. If you access or use our
            Services from outside the jurisdiction in which Bonfiire operates,
            you are responsible for complying with local laws, including any
            regulations regarding data protection, privacy, and online conduct.
          </p>
        </div>
      </section>
      <section style={{ textAlign: "left", marginTop: "30px" }}>
        <h2>Contact Us</h2>
        <div className="pDiv">
          <p>
            If you have any questions, concerns, or require further
            clarification regarding these Terms and Conditions, please contact
            us at:
          </p>
          <p>
            {" "}
            <a href="mailto:support@bonfiire.io">support@bonfiire.io</a>
          </p>
        </div>
      </section>
    </div>
  );
};

export default TermsPage;
